if (!customElements.get('editable-mentor-program')) {
  class EditableMentorProgram extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.track = this.querySelector('[data-emp-track]');
      this.cards = [...this.querySelectorAll('[data-emp-card]')];
      this.dots = [...this.querySelectorAll('[data-emp-dot]')];
      if (!this.track || !this.cards.length) return;

      this.raf = 0;
      this.track.addEventListener('scroll', () => this.queueActiveUpdate(), { passive: true });
      this.track.addEventListener('keydown', (event) => this.handleKeys(event));
      this.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-emp-dot]');
        if (!dot || !this.contains(dot)) return;
        this.scrollToCard(Number(dot.dataset.empDot));
      });
      this.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('[data-emp-card]');
        const index = this.cards.indexOf(card);
        if (index >= 0) this.scrollToCard(index, false);
      });
    }

    queueActiveUpdate() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = 0;
        this.updateActiveDot();
      });
    }

    updateActiveDot() {
      // The last cards cannot scroll to the start edge, so "nearest to the
      // start" never picks them; reaching the end of the track has to mean the
      // last card, or its dot can never light up.
      // Only when the track can travel at least half a card, though: when the
      // cards all but fit, a few pixels of scroll must not light the last dot.
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const step = this.cards.length > 1 ? this.cards[1].offsetLeft - this.cards[0].offsetLeft : 0;
      if (maxScroll > step / 2 && this.track.scrollLeft >= maxScroll - 1) {
        this.setActiveDot(this.cards.length - 1);
        return;
      }

      const trackLeft = this.track.getBoundingClientRect().left;
      let activeIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;
      this.cards.forEach((card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          activeIndex = index;
        }
      });
      this.setActiveDot(activeIndex);
    }

    setActiveDot(activeIndex) {
      this.dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });
    }

    scrollToCard(index, smooth = true) {
      const card = this.cards[index];
      if (!card) return;
      // Measured from the first card, which rests at scroll 0; measuring from the
      // track edge ignored its inline padding, and snapping then carried the
      // second-to-last card all the way to the end.
      const left = card.offsetLeft - this.cards[0].offsetLeft;
      this.track.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
      this.setActiveDot(index);
    }

    handleKeys(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const current = this.dots.findIndex((dot) => dot.classList.contains('is-active'));
      let next = current < 0 ? 0 : current;
      if (event.key === 'ArrowRight') next = Math.min(this.cards.length - 1, next + 1);
      if (event.key === 'ArrowLeft') next = Math.max(0, next - 1);
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.cards.length - 1;
      event.preventDefault();
      this.scrollToCard(next);
    }
  }

  customElements.define('editable-mentor-program', EditableMentorProgram);
}
